import React from 'react';
import { Redirect, Route } from 'react-router-dom';

// Utils
import auth from './auth';

// const getToken = auth.getToken();
// const getToken = "dev";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    auth.getToken() !== null ? (
      <Component {...props} />
    ) : (
      <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
        }}
      />
    )
  )}
  />
);

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/base/PrivateRoute.js